import { fontLabels, fontsKeys, fontsValues } from '@email-editor/ui'
import { FormSelect, FormSelectDataType } from '@systemeio/ui'
import Option from '../../components/Option'

const options: FormSelectDataType<string>[] = Object.keys(fontsKeys).map(fontKey => ({
  id: fontsValues[fontKey],
  caption: fontLabels[fontKey],
  customCaption: <span style={{ fontFamily: fontsValues[fontKey] }}>{fontLabels[fontKey]}</span>,
}))

type FontFamilyProps = {
  label?: string
  update: (value: string) => void
  value?: string
}

function FontFamily({
  label = 'settings_options.font_family.label',
  update,
  value,
}: FontFamilyProps) {
  return (
    <Option label={label}>
      <FormSelect
        value={value}
        data={options}
        onChange={option => {
          update(option as string)
        }}
        withoutCloseIcon
      />
    </Option>
  )
}

export default FontFamily
